import PropTypes from "prop-types";
import { RichUtils } from "draft-js";
import insertEntity from "./utils/insertEntity";

/**
 * @param {EditorState} editorState
 * @param {Function}    onChange
 * @param {Function}    onInsert
 */
function handleInsertEntity(editorState, onChange) {
  return (entityType, data, mutability = "MUTABLE") => {
    if (entityType) {
      const afterInsert = insertEntity(editorState, entityType, data, mutability);
      onChange(afterInsert);
    }
  };
}

/**
 * @param {EditorState} editorState
 * @param {Function}    onChange
 * @param {Function}    onRemove
 */
function handleRemoveEntity(editorState, onChange) {
  return () => {
    const currentSelection = editorState.getSelection();

    if (currentSelection.isCollapsed() === false) {
      const afterRemove = RichUtils.toggleLink(editorState, currentSelection, null);
      onChange(afterRemove);
    }
  };
}

export default function EditorEntityHandling({ editorState, onChange, children }) {
  return children({
    insertEntity: handleInsertEntity(editorState, onChange),
    removeEntity: handleRemoveEntity(editorState, onChange),
  });
}

EditorEntityHandling.propTypes = {
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
